import { Spin, Statistic, message, Table, Tag } from "antd";
import React from "react";
import {
  apiCallPost,
  indianRupee,
  niceDate,
  niceDateTime,
  niceTime,
} from "./fns/util";
import _ from "lodash";

class StatDash extends React.Component {
  state = {
    isLoading: true,
    videoScores: [],
    submissionStats: [],
    delegateStats: {
      total: 0,
      member: 0,
      notMember: 0,
    },
  };
  componentDidMount() {
    this.getSubmissionStats();
    this.getVideoScores();
    this.getOPCScores();
  }
  videoColumns = [
    {
      title: "#",
      key: "serialNumber",
      dataIndex: "serialNumber",
    },
    { title: "Title", key: "title", dataIndex: "title" },
    {
      title: "Primary Author",
      key: "presentingAuthorName",
      dataIndex: "presentingAuthorName",
    },
    {
      title: "Authors",
      key: "authors",
      dataIndex: "authors",
      render: (x, record) => {
        return (
          <p className="smaller_text">
            {_.join(
              _.map(
                record.authors,
                (a) => `${a.name} [${a.email} | ${a.mobile}]`
              ),
              ", "
            )}
          </p>
        );
      },
    },
    {
      title: "Individual Scores",
      key: "scores",
      dataIndex: "scores",
      render: (x, record) => {
        const scoresHtml = [];
        /**
         *  Presentation, Originality, ScientificContent, CinematicContent
         */
        for (let s of record.scores) {
          const total =
            parseInt(s.Presentation) +
            parseInt(s.Originality) +
            parseInt(s.ScientificContent) +
            parseInt(s.CinematicContent);
          scoresHtml.push(
            <Tag color="blue">
              {s.judgeName}: P: {s.Presentation}, O: {s.Originality}, S:{" "}
              {s.ScientificContent}, C: {s.CinematicContent}; Total: {total}
            </Tag>
          );
        }
        return <p className="smaller_text">{scoresHtml}</p>;
      },
    },
    {
      title: "Average Score",
      key: "scores",
      dataIndex: "scores",
      render: (x, record) => {
        const avg = record.avgScore;
        return <p className="smaller_text">{avg}</p>;
      },
      sorter: (a, b) => {
        return a.avgScore - b.avgScore;
      },
    },
  ];
  getSubmissionStats = async () => {
    let token = await this.props.context.provideToken();
    try {
      let res = await apiCallPost(
        token,
        "/conference2023/dashboard/getSubmissionCounts",
        {}
      );
      let transformed = this.transformSubmissionStats(res.counts);
      this.setState({ submissionStats: transformed }, () =>
        this.getDelegateStats()
      );
    } catch (err) {
      message.error("Error getting submission stats");
    }
  };
  getDelegateStats = async () => {
    let token = await this.props.context.provideToken();
    try {
      let res = await apiCallPost(
        token,
        "/conference2023/dashboard/getDelegateCounts",
        {}
      );
      let transformed = this.transformDelegateStats(res);
      let transformed2 = this.transformRegnCountStats(res);
      this.setState(
        { delegateStats: transformed, regnCountStats: transformed2 },
        () => this.getRegnStats()
      );
    } catch (err) {
      message.error("Error getting delegate stats");
    }
  };
  getRegnStats = async () => {
    let token = await this.props.context.provideToken();
    try {
      let res = await apiCallPost(
        token,
        "/conference2023/dashboard/getCashCollection",
        {}
      );
      let counts = res.counts;
      let offline = 0;
      let online = 0;
      for (var i = 0; i < counts.length; i++) {
        let type = counts[i]._id.offline;
        if (type === null) {
          continue;
        }
        if (counts[i]._id.offline) {
          offline = counts[i].totalAmount;
        } else {
          online = counts[i].totalAmount;
        }
      }

      this.setState({ online: online, offline: offline, isLoading: false });
    } catch (err) {
      message.error("Error getting delegate stats");
    }
  };
  getVideoScores = async () => {
    let token = await this.props.context.provideToken();
    try {
      let res = await apiCallPost(
        token,
        "/conference2023/dashboard/getVideoScores",
        {}
      );
      this.setState({ videoScores: res.videoScores });
    } catch (err) {
      message.error("Error getting delegate stats");
    }
  };
  getOPCScores = async () => {
    let token = await this.props.context.provideToken();
    try {
      let res = await apiCallPost(
        token,
        "/conference2023/dashboard/getOPCScores",
        {}
      );
      this.setState({ opcScores: res.videoScores });
    } catch (err) {
      message.error("Error getting delegate stats");
    }
  };
  transformDelegateStats(data) {
    let total = 0,
      member = 0,
      notMember = 0;

    // Iterate over counts array
    data.counts.forEach((countObj) => {
      total += countObj.count;
      countObj._id.isOSWBMember
        ? (member += countObj.count)
        : (notMember += countObj.count);
    });

    return { total, member, notMember };
  }
  transformRegnCountStats(data) {
    let bp = data.countsByBP.map((each) => {
      return { persona: each._id.billingPersona, count: each.count };
    });

    return bp;
  }

  transformSubmissionStats(jsonArray) {
    let output = [];

    // Initialize output objects
    const submissionTypes = ["IC", "VIDEO", "PAPER", "POSTER"];
    for (let type of submissionTypes) {
      let obj = { submissionType: type };
      obj["SUBMITTED"] = 0;
      obj["DRAFT"] = 0;
      output.push(obj);
    }

    // Iterate through given JSON Array
    for (let item of jsonArray) {
      let type = item._id.submissionType;
      let lifeCycle = item._id.lifecycle;
      let count = item.count;

      // Find the correct object and update its properties
      for (let obj of output) {
        if (obj.submissionType === type) {
          obj[lifeCycle] = count;
        }
      }
    }

    return output;
  }
  render() {
    return (
      <div>
        <h2>Quick Stats</h2>
        {this.state.isLoading ? (
          <Spin />
        ) : (
          <div
            style={{
              display: "flex",
              flexWrap: "wrap",
              justifyContent: "space-around",
              alignItems: "center",
              width: "80%",
            }}
          >
            {this.state.submissionStats.map((each) => {
              return (
                <div style={{ marginTop: "20px", marginRight: "20px" }}>
                  <Statistic
                    title={each.submissionType}
                    value={each.DRAFT + each.SUBMITTED}
                    suffix="Total"
                  />
                  <Statistic value={each.SUBMITTED} suffix="Submissions" />
                  <Statistic value={each.DRAFT} suffix="Drafts" />
                </div>
              );
            })}
            <div style={{ marginTop: "20px", marginRight: "20px" }}>
              <Statistic
                title="Portal Users"
                value={this.state.delegateStats.total}
                suffix="Total"
              />
              <Statistic
                value={this.state.delegateStats.member}
                suffix="Members"
              />
              <Statistic
                value={this.state.delegateStats.notMember}
                suffix="Non-Members"
              />
            </div>{" "}
            <div style={{ marginTop: "20px", marginRight: "20px" }}>
              <Statistic
                title="Registration Counts"
                value={_.sumBy(this.state.regnCountStats, "count")}
                suffix="Total"
              />
              {this.state.regnCountStats.map((each, ix) => {
                return (
                  <Statistic
                    value={each.count}
                    suffix={each.persona}
                    key={ix}
                  />
                );
              })}
            </div>
            <div style={{ marginTop: "20px", marginRight: "20px" }}>
              <Statistic
                title="Registration Fees"
                value={indianRupee(this.state.online + this.state.offline, 0)}
                suffix="Total"
              />
              <Statistic
                value={indianRupee(this.state.offline, 0)}
                suffix="Offline"
              />
              <Statistic
                value={indianRupee(this.state.online, 0)}
                suffix="Online"
              />
            </div>
            <div style={{ marginTop: "20px", marginLeft: "250px" }}>
              <h2> Video Submission Scores:</h2>
              <details>
                <Table
                  dataSource={[...this.state.videoScores]}
                  columns={this.videoColumns}
                  rowKey={(record) => {
                    return `submission__${record._id}__${record.updatedAt}__`;
                  }}
                  size="small"
                  pagination={{
                    defaultPageSize: 100,
                  }}
                />
              </details>
            </div>
            <div style={{ marginTop: "20px", marginLeft: "250px" }}>
              <h2> OPC Submission Scores:</h2>
              <details>
                <Table
                  dataSource={[...this.state.opcScores]}
                  columns={this.videoColumns}
                  rowKey={(record) => {
                    return `submission__${record._id}__${record.updatedAt}__`;
                  }}
                  size="small"
                  pagination={{
                    defaultPageSize: 100,
                  }}
                />
              </details>
            </div>
          </div>
        )}
      </div>
    );
  }
}
export default StatDash;
